import { render, staticRenderFns } from "./UserSpecPlanCard.vue?vue&type=template&id=657ff22f&scoped=true"
import script from "./UserSpecPlanCard.vue?vue&type=script&lang=js"
export * from "./UserSpecPlanCard.vue?vue&type=script&lang=js"
import style0 from "./UserSpecPlanCard.vue?vue&type=style&index=0&id=657ff22f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657ff22f",
  null
  
)

export default component.exports